import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import { NavLink } from "react-router-dom";

import { useUsers } from "hooks";
import { appRoutes } from "routes";
import logoVertical from "assets/images/common/logo-vertical.png";
import Navigation from "layouts/UserLayout/components/Header/components/Navigation";
import UserPresenter from "presenters/UserPresenter";
import ResponsiveImage from "components/ResponsiveImage";

import useStyles from "./useStyles";

const DesktopHeader = (props) => {
  const classes = useStyles();
  const { onDrawerOpen } = props;
  const { currentUser } = useUsers();

  return (
    <div className={classes.root}>
      <NavLink to={appRoutes.rootPath()}>
        <ResponsiveImage
          src={logoVertical}
          alt="JibJab"
          className={classes.logo}
          height={68}
          width={75}
          widthMobile={75}
        />
      </NavLink>

      <div className={classes.nav}>
        <Navigation {...props} />
      </div>

      <div className={classes.actions}>
        <div className={classes.action}>
          <NavLink color="inherit" aria-label="search" to={appRoutes.searchPath()}>
            <SearchIcon className={classes.searchIcon} />
          </NavLink>
        </div>
        {!UserPresenter.isRegistered(currentUser) && (
          <div className={classes.action}>
            <NavLink className={classes.buttonLink} to={appRoutes.signUpPath()}>
              Sign Up
            </NavLink>
          </div>
        )}
        {UserPresenter.isRegistered(currentUser) && !UserPresenter.isPaid(currentUser) && (
          <div className={classes.action}>
            <NavLink className={classes.buttonLink} to={appRoutes.paymentPath()}>
              <span>Upgrade</span>
            </NavLink>
          </div>
        )}
        <div className={classes.action}>
          <IconButton
            className={classes.menuIconButton}
            disableRipple={false}
            disableFocusRipple={false}
            color="inherit"
            aria-label="menu"
            onClick={onDrawerOpen}
          >
            <MenuIcon className={classes.menuIcon} />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

DesktopHeader.propTypes = {
  onDrawerOpen: PropTypes.func.isRequired,
};

export default DesktopHeader;
